// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qc4P9","controls":"styles_controls__7wFPQ","charLimit":"styles_charLimit__1sPIA","input":"styles_input__2EapI","send":"styles_send__j_U7_"};